import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Button, Container, Grid, Icon, Message } from 'semantic-ui-react'
import { FaFlag } from 'react-icons/fa'
import { useEditHandleError } from '../../Common/Hooks/useEditHandleError'
import { loadEsrbById, newEsrb, saveEsrb, updateState } from '../Slice/EsrbSlice'
import EsrbForm from '../Form/EsrbForm'
import './css/EsrbListPage.css'

export default function EsrbEditPage () {
  const { t } = useTranslation()
  const {
    isLoading,
    isSuccess,
    isError,
    message
  } = useSelector((state) => state.esrb)
  const dispatch = useDispatch()
  const { esrbId } = useParams()
  const [errorList, goBack, handleError] = useEditHandleError('/esrb')

  useEffect(() => {
    if (esrbId === 'new') {
      dispatch(newEsrb())
    } else {
      dispatch(loadEsrbById(esrbId))
    }
  }, [])

  useEffect(() => {
    handleError(isSuccess, isError, message)
    dispatch(updateState())
  }, [isSuccess, isError, message])

  const onSaveEsrb = () => {
    dispatch(saveEsrb())
  }

  return (
    <Container className='esrb-list-page'>
      <div className="esrb-title esrb-division">
        <Grid columns={2}>
          <Grid.Column>
            <Icon size='large'><FaFlag /></Icon>
            {
              esrbId === 'new'
                ? (<span>{ t('esrb.new') }</span>)
                : (<>
                  <span>{ t('esrb.edit') }</span>
                  <small className='mx-3'># { esrbId }</small>
                </>)
            }
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button
              icon
              labelPosition='left'
              color='grey'
              size='large'
              disabled={isLoading}
              onClick={goBack}>
              <Icon name='arrow circle left' /> { t('generic.goBack') }
            </Button>
            <Button
              icon
              labelPosition='left'
              color='green'
              size='large'
              disabled={isLoading}
              onClick={onSaveEsrb}>
              <Icon name='save' /> { t('generic.save') }
            </Button>
          </Grid.Column>
        </Grid>
      </div>
      <div className='p-4'>
        <EsrbForm />
      </div>
      <div className="p-4">
        { errorList.length > 0 &&
          <Message error icon='exclamation triangle'
                   header={ t('generic.validation.onSave') }
                   list={errorList} />
        }
      </div>
    </Container>
  )
}
